const getDaysInMonth = (month: number): number => {
  if (month <= 0 || month > 12) {
    return NaN;
  }
  if (month === 2) {
    // February
    // since we don't know the year ahead of time, we can't calcualte
    // if its leap year or not ahead of time, so default to 29 days
    return 29;
  }
  if ([4, 6, 9, 11].includes(month)) {
    // April, June, September, November
    return 30;
  }
  return 31; // All other months
};

const handleDateInput = ({
  previousValue,
  newValue,
  format,
}: {
  previousValue: string;
  newValue: string;
  format: 'short' | 'long';
}): string => {
  const digits = newValue.replace(/\D/g, '');

  const month = digits.slice(0, 2);
  const day = digits.slice(2, 4);
  const year = digits.slice(4, 8);

  let formattedValue = '';

  // Detect backspace at slash
  const isBackspace = newValue.length < previousValue.length;
  if (isBackspace) {
    if (previousValue.endsWith('/')) {
      return previousValue.slice(0, -1);
    }
  }

  const monthNumber = parseInt(month, 10);
  if (monthNumber > 12 || (monthNumber === 0 && month.length === 2)) {
    return previousValue;
  }

  if (month.length === 1 && monthNumber > 1) {
    formattedValue = `0${month}/`;
  } else if (month.length === 2) {
    formattedValue = `${month}/`;
  } else {
    formattedValue = month;
  }

  const dayNumber = parseInt(day, 10);
  const daysInMonth = getDaysInMonth(monthNumber);
  if (dayNumber > daysInMonth || (dayNumber === 0 && day.length === 2)) {
    return previousValue;
  }

  if (day.length === 1 && dayNumber > 3) {
    formattedValue += `0${day}/`;
    // adjust for when month is February and user enters day > 2, prefix with 0
  } else if (day.length === 1 && month === '02' && dayNumber > 2) {
    formattedValue += `0${day}/`;
  } else if (day.length === 2) {
    formattedValue += `${day}/`;
  } else {
    formattedValue += day;
  }

  if (format === 'short') {
    return formattedValue.length === 6
      ? formattedValue.slice(0, -1) // remove trailing slash
      : formattedValue;
  }

  if (year.length > 0) {
    const yearNumber = parseInt(year, 10);

    if (year.length === 1 && yearNumber !== 1 && yearNumber !== 2) {
      return previousValue;
    }
    if (year.length === 2 && yearNumber !== 20 && yearNumber !== 19) {
      return previousValue;
    }
    if (year.length === 4 && (yearNumber < 1900 || yearNumber > 2099)) {
      return previousValue;
    }
  }

  formattedValue += year;

  return formattedValue;
};

export { handleDateInput, getDaysInMonth };
